export default {
      apiKey: "AIzaSyDzAx_OefBlVW301f-RlhQN2QGK9v0Mf6o",
      authDomain: "aibolitmd-member.firebaseapp.com",
      databaseURL: "https://aibolitmd-member.firebaseio.com",
      projectId: "aibolitmd-member",
      storageBucket: "aibolitmd-member.appspot.com",
      messagingSenderId: "576232927202",
      appId: "1:576232927202:web:28c94756a9ead482e253bb",
      measurementId: "G-M67S4DWKQX"
}